import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import { useAuthStore } from "../stores/authStore";

import AuthLayout from "../layouts/AuthLayout";
import AppLayout from "../layouts/AppLayout";

import AuthPage from "../pages/AuthPage";
import ForgotPasswordPage from "../pages/ForgotPasswordPage";
import ResetPasswordPage from "../pages/ResetPasswordPage";
import LeadVerifyPage from "../pages/LeadVerifyPage";
import LeadWelcomePage from "../pages/LeadWelcomePage";

import MapPage from "../pages/MapPage";
import AccountPage from "../pages/AccountPage";
import MeetingsPage from "../pages/MeetingsPage";
import CreateMeetingPage from "../pages/CreateMeetingPage";
import MeetingDetailPage from "../pages/MeetingDetailPage";
import SubscriptionPage from "../pages/SubscriptionPage";
import NotificationsPage from "../pages/NotificationsPage";

function ProtectedRoute() {
  const token = useAuthStore((s) => s.token);
  if (!token) {
    return <Navigate to="/auth" replace />;
  }
  return <Outlet />;
}

function GuestRoute() {
  const token = useAuthStore((s) => s.token);
  if (token) {
    return <Navigate to="/map" replace />;
  }
  return <Outlet />;
}

export default function AppRouter() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Onboarding público: URL amigable /rules/{…segmentos backend…}?query — pantalla completa */}
        <Route path="/rules/*" element={<LeadWelcomePage />} />
        {/* Compat: enlaces antiguos que apunten al path tipo API en el host del SPA */}
        <Route path="/v1/lead/welcome-check/*" element={<LeadWelcomePage />} />
        <Route path="/lead/welcome-check/*" element={<LeadWelcomePage />} />

        <Route element={<AuthLayout />}>
          <Route element={<GuestRoute />}>
            <Route path="/auth" element={<AuthPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          </Route>
          <Route path="/reset-password/:token" element={<ResetPasswordPage />} />
          <Route path="/lead/verify/:leadId/:hash" element={<LeadVerifyPage />} />
        </Route>

        <Route element={<ProtectedRoute />}>
          <Route element={<AppLayout />}>
            <Route path="/map" element={<MapPage />} />
            <Route path="/meetings" element={<MeetingsPage />} />
            <Route path="/meetings/new" element={<CreateMeetingPage />} />
            <Route path="/meetings/:id" element={<MeetingDetailPage />} />
            <Route path="/account" element={<AccountPage />} />
            <Route path="/subscription" element={<SubscriptionPage />} />
            <Route path="/notifications" element={<NotificationsPage />} />
          </Route>
        </Route>

        <Route path="/" element={<Navigate to="/auth" replace />} />
        <Route path="*" element={<Navigate to="/auth" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
